// src/pages/CourseTime/components/slides/layouts/RecapSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import NoDataFallback from '../common/NoDataFallback.comp';
import SlideTitleSpoken from '../common/SlideTitleSpoken.comp';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';

// Layout: TemplateRecap
const RecapSlide = ({ slide, renderSpokenText, skipTitleSpeech, themeColor }) => {
  const { renderContent } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  // Newer content keeps these fields on the slide itself (no RecapData).
  const r = slide.RecapData
    || ((slide.big_idea_question || slide.answer || slide.support_points || slide.short_answer) ? slide : null);
  const accent = themeColor || '#3D5AFE';
  // Fallback: structured data missing (older content) → render HTML.
  if (!r) {
    return (
      <NoDataFallback
        slide={slide}
        skipTitleSpeech={skipTitleSpeech}
        renderSpokenText={renderSpokenText}
        renderContent={renderContent}
      />
    );
  }
  return (
    <S.SlideDescription>
      <S.SlideTitle>
        <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
      </S.SlideTitle>

      {r.big_idea_question && (
        <div
          style={{
            borderLeft: `4px solid ${accent}`,
            background: 'rgba(61, 90, 254, 0.06)',
            padding: '12px 16px',
            borderRadius: 8,
            margin: '8px 0 16px',
            fontWeight: 600,
          }}
        >
          {renderContent('recap_question', r.big_idea_question)}
        </div>
      )}

      {r.is_t7 ? (
        <>
          {r.short_answer && (
            <S.PointText>
              <strong>{r.short_answer_title || 'The short answer:'}</strong>{' '}
              {renderContent('recap_short', r.short_answer)}
            </S.PointText>
          )}
          {r.long_answer_title && (
            <S.PointText style={{ fontWeight: 600, marginTop: 8 }}>
              {r.long_answer_title}
            </S.PointText>
          )}
          <ul>
            {(r.support_points || []).map((p, idx) => (
              <li key={idx}>
                <S.PointText>
                  <strong>{p.heading}</strong>
                  {p.heading && p.explanation ? ' — ' : ''}
                  {renderContent(`recap_pt_${idx}`, p.explanation || '')}
                </S.PointText>
              </li>
            ))}
          </ul>
          {r.bulb_insight && (
            <div
              style={{
                background: 'rgba(255, 193, 7, 0.12)',
                padding: '12px 16px',
                borderRadius: 8,
                marginTop: 12,
              }}
            >
              <S.PointText>💡 {renderContent('recap_bulb', r.bulb_insight)}</S.PointText>
            </div>
          )}
        </>
      ) : (
        <>
          {r.answer && (
            <S.PointText style={{ fontSize: '1.05em', marginBottom: 12 }}>
              {renderContent('recap_answer', r.answer)}
            </S.PointText>
          )}
          <ul>
            {(r.support_points || []).map((p, idx) => (
              <li key={idx}>
                <S.PointText>{renderContent(`recap_pt_${idx}`, p)}</S.PointText>
              </li>
            ))}
          </ul>
        </>
      )}
    </S.SlideDescription>
  );
};

export default RecapSlide;
